import React, { useState } from "react";
import {
  Box,
  Typography,
  TextField,
  IconButton,
  Select,
  MenuItem,
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Grid,
  Divider,
} from "@mui/material";
import styled from "styled-components";

import Sidebar from "./Sidebar";
import ListViewIconBlue from "../../../assets/images/ListView_Blue.png";
import ListViewIconBlack from "../../../assets/images/ListView_Black.png";
import GridViewIconBlue from "../../../assets/images/GridView_Blue.png";
import GridViewIconBlack from "../../../assets/images/GridView_Black.png";
import GlobeViewIconBlue from "../../../assets/images/GlobeView_Blue.png";
import GlobeViewIconBlack from "../../../assets/images/GlobeView_Black.png";

import NavigationBar from "../../../components/nav/NavigationBar.tsx";

const Container = styled.div`
  align-items: stretch;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  // gap: 0px;
  justify-content: flex-start;
  padding: clamp(40px, 10vw, 80px) 0 0 0;
  position: relative;
`;

const Dashboard = () => {
  const [viewMode, setViewMode] = useState("list");
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [sortBy, setSortBy] = useState("name");
  const [selectedSidebarOptions, setSelectedSidebarOptions] = useState<string[]>([]);

  const isFaultedView =
    selectedSidebarOptions.length === 1 &&
    selectedSidebarOptions[0] === "View Faulted Stations";

  const chargingStations = [
    {
      name: "Station Alpha",
      id: "12345",
      status: "operational",
      faultType: "Overheating",
      timestamp: "2023-10-01 12:00:00",
      address: "123 Main St, Cityville",
      region: "Northeast",
      operator: "Operator X",
    },
    {
      name: "Station Beta",
      id: "67890",
      status: "operational",
      faultType: "None",
      timestamp: "2023-10-02 09:30:00",
      address: "456 Elm St, Townville",
      region: "Southeast",
      operator: "Operator Y",
    },
    {
      name: "Station Gamma",
      id: "11223",
      status: "maintenance",
      faultType: "Hardware Failure",
      timestamp: "2023-10-05 15:45:00",
      address: "789 Pine St, Villagetown",
      region: "Midwest",
      operator: "Operator Z",
    },
  ];

  const filteredStations = chargingStations.filter(
    (station) =>
      station.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      station.id.includes(searchQuery)
  );

  const sortedStations = filteredStations.sort((a, b) => {
    if (sortBy === "name") return a.name.localeCompare(b.name);
    if (sortBy === "status") return a.status.localeCompare(b.status);
    if (sortBy === "region") return a.region.localeCompare(b.region);
    return 0;
  });

  const getStatusColor = (status: string) => {
    switch (status.toLowerCase()) {
      case "faulted":
        return "var(--header-red)";
      case "operational":
        return "var(--header-green)";
      case "maintenance":
        return "var(--header-yellow)";
      case "idle":
        return "var(--header-blue)";
      default:
        return "gray";
    }
  };

  return (
    <Container>
      <NavigationBar />
      <Box p={3} fontFamily="Arial, sans-serif">
        <Typography variant="h4" align="center" fontWeight="bold" gutterBottom>
          Dashboard
        </Typography>

        <Box display="flex" alignItems="center" mb={3} flexWrap="wrap" gap={2}>
          <Box flexGrow={1} minWidth={200}>
            <TextField
              label="Search"
              variant="outlined"
              fullWidth
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </Box>

          <Box display="flex" alignItems="center" gap={1} flexWrap="wrap">
            <IconButton onClick={() => setViewMode("list")}>
              <img
                src={viewMode === "list" ? ListViewIconBlue : ListViewIconBlack}
                alt="List View"
                width={24}
                height={24}
              />
            </IconButton>
            <IconButton onClick={() => setViewMode("grid")}>
              <img
                src={viewMode === "grid" ? GridViewIconBlue : GridViewIconBlack}
                alt="Grid View"
                width={24}
                height={24}
              />
            </IconButton>
            <IconButton onClick={() => setViewMode("globe")}>
              <img
                src={viewMode === "globe" ? GlobeViewIconBlue : GlobeViewIconBlack}
                alt="Globe View"
                width={24}
                height={24}
              />
            </IconButton>

            <Select
              value={sortBy}
              onChange={(e) => setSortBy(e.target.value)}
              size="small"
              displayEmpty
            >
              <MenuItem value="name">Sort by Name</MenuItem>
              <MenuItem value="status">Sort by Status</MenuItem>
              <MenuItem value="region">Sort by Region</MenuItem>
            </Select>

            <Button
              variant="contained"
              size="medium"
              sx={{ backgroundColor: "var(--terbine-blue)", color: "#fff", boxShadow: "None" }}
            >
              Filter
            </Button>
          </Box>
        </Box>
        <Box display="flex">
          <Box position="relative">
          <Box display="flex">
            <Box
              sx={{
                width: isSidebarCollapsed ? 0 : "320px",
                minWidth: isSidebarCollapsed ? 0 : "320px",
                overflow: "hidden",
                transition: "all 0.3s ease",
              }}
            >
              <Sidebar
                collapsed={isSidebarCollapsed}
                setCollapsed={setIsSidebarCollapsed}
                selectedOptions={selectedSidebarOptions}
                setSelectedOptions={setSelectedSidebarOptions}
              />
            </Box>

            <Box sx={{ flexGrow: 1, transition: "all 0.3s ease", pl: 3 }}>
            </Box>
          </Box>

          <Box
            sx={{
              position: "absolute",
              top: 0,
              left: isSidebarCollapsed ? 0 : "308px",
              width: "30px",
              height: "40px",
              backgroundColor: "#e0e0e0",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 100,
              borderTopRightRadius: 4,
              borderBottomRightRadius: 4,
              transition: "left 0.3s ease",
            }}
          >
            <IconButton
              onClick={() => setIsSidebarCollapsed(!isSidebarCollapsed)}
              size="small"
              sx={{ width: 20, height: 20, padding: 0 }}
            >
              <span
                style={{
                  display: "block",
                  transform: isSidebarCollapsed ? "rotate(0deg)" : "rotate(180deg)",
                  fontSize: "14px",
                }}
              >
                ▶
              </span>
            </IconButton>
          </Box>
        </Box>

          <Box sx={{ flexGrow: 1, transition: "all 0.3s ease", pl: 3 }}>
            {viewMode === "list" ? (
              isFaultedView ? (
                <TableContainer
                  component={Paper}
                  sx={{
                    borderRadius: "8px",
                    overflow: "hidden",
                    boxShadow: "none",
                    width: "100%",
                  }}
                >
                  <Table>
                    <TableHead
                      sx={{
                        backgroundColor: "var(--terbine-blue)",
                        "& th": {
                          color: "var(--terbine-white)",
                          fontSize: "clamp(12px, 1.5vw, 18px)",
                          fontWeight: 300,
                        },
                      }}
                    >
                      <TableRow>
                        <TableCell>Station Name</TableCell>
                        <TableCell>Station ID</TableCell>
                        <TableCell>Fault Type</TableCell>
                        <TableCell>Timestamp</TableCell>
                        <TableCell>Region</TableCell>
                        <TableCell>By User</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody
                      sx={{
                        "& tr": { backgroundColor: "#F2F2F2", },
                        "& td": {
                          color: "#000",
                          fontSize: "clamp(12px, 1.5vw, 16px)",
                        },
                      }}
                    >
                      {sortedStations.map((station, idx) => (
                        <TableRow
                          key={idx}
                          sx={{
                            borderBottom:
                              idx !== sortedStations.length - 1 ? "3px solid white" : "none",
                          }}
                        >
                          <TableCell>{station.name}</TableCell>
                          <TableCell>{station.id}</TableCell>
                          <TableCell>{station.faultType}</TableCell>
                          <TableCell>{station.timestamp}</TableCell>
                          <TableCell>{station.region}</TableCell>
                          <TableCell>{station.operator}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              ) : (
                <TableContainer
                  component={Paper}
                  sx={{
                    borderRadius: "8px",
                    overflow: "hidden",
                    boxShadow: "none",
                    width: "100%",
                  }}
                >
                  <Table>
                    <TableHead
                      sx={{
                        backgroundColor: "var(--terbine-blue)",
                        "& th": {
                          color: "var(--terbine-white)",
                          fontSize: "clamp(12px, 1.5vw, 18px)",
                          fontWeight: 300,
                        },
                      }}
                    >
                      <TableRow>
                        <TableCell>Status</TableCell>
                        <TableCell>Station Name</TableCell>
                        <TableCell>Station ID</TableCell>
                        <TableCell>Address</TableCell>
                        <TableCell>Region</TableCell>
                        <TableCell>By User</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody
                      sx={{
                        "& tr": { backgroundColor: "#F2F2F2", },
                        "& td": {
                          color: "#000",
                          fontSize: "clamp(12px, 1.5vw, 16px)",
                        },
                      }}
                    >
                      {sortedStations.map((station, idx) => (
                        <TableRow
                          key={idx}
                          sx={{
                            borderBottom:
                              idx !== sortedStations.length - 1 ? "3px solid white" : "none",
                          }}
                        >
                          <TableCell>
                            <Box
                              sx={{
                                width: 12,
                                height: 12,
                                borderRadius: "50%",
                                backgroundColor: getStatusColor(station.status),
                              }}
                            />
                          </TableCell>
                          <TableCell>{station.name}</TableCell>
                          <TableCell>{station.id}</TableCell>
                          <TableCell>{station.address}</TableCell>
                          <TableCell>{station.region}</TableCell>
                          <TableCell>{station.operator}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              )
            ) : (
              <Grid container spacing={3}>
                {sortedStations.map((station, index) => {
                  const normalizedStatus = station.status?.trim().toLowerCase();

                  const statusColors: { [key: string]: string } = {
                    operational: "var(--header-green)",
                    "not working": "var(--header-red)",
                    maintenance: "var(--header-blue)",
                    "cyber attack": "var(--header-yellow)",
                  };

                  const statusColor = statusColors[normalizedStatus] || "#999";

                  return (
                    <Grid item xs={12} sm={6} md={4} key={index}>
                      <Paper
                        variant="outlined"
                        sx={{
                          boxShadow: "none",
                          textAlign: "left",
                          p: 0,
                          overflow: "hidden",
                          borderRadius: 1,
                        }}
                      >
                        {/* Title Block */}
                        <Box
                          sx={{
                            backgroundColor: statusColor,
                            color: "#fff",
                            py: 1.5,
                            width: "100%",
                            textAlign: "center"
                          }}
                        >
                          <Typography
                            variant="subtitle1"
                            sx={{ fontWeight: "bold", lineHeight: 1.3 }}
                          >
                            {station.name} / {station.region}
                          </Typography>
                          <Typography variant="body2">
                            StationID: {station.id}
                          </Typography>
                        </Box>

                        {/* Station Info */}
                        <Box sx={{ px: 3, py: 2 }}>
                          <Typography variant="body2" sx={{ mb: 0.5 }}>
                            <strong>Address:</strong> {station.address}
                          </Typography>
                          <Typography variant="body2" sx={{ mb: 0.5 }}>
                            <strong>Region:</strong> {station.region}
                          </Typography>
                          <Typography variant="body2" sx={{ mb: 0.5 }}>
                            <strong>Operator:</strong> {station.operator}
                          </Typography>
                          <Typography variant="body2" sx={{ mb: 0.5 }}>
                            <strong>Status:</strong> {station.status}
                          </Typography>
                          <Typography variant="body2" sx={{ mb: 0.5 }}>
                            <strong>Fault Type:</strong> {station.faultType}
                          </Typography>
                          <Typography variant="body2">
                            <strong>Timestamp:</strong> {station.timestamp}
                          </Typography>
                          <Box display="flex" justifyContent="center" mt={2}>
                            <Button
                              variant="contained"
                              size="small"
                              sx={{
                                backgroundColor: "var(--terbine-blue)",
                                color: "#fff",
                                textTransform: "none",
                                boxShadow: "none",
                                "&:hover": {
                                  backgroundColor: "var(--terbine-blue)",
                                  boxShadow: "none",
                                },
                              }}
                            >
                              View Station →
                            </Button>
                          </Box>
                        </Box>
                      </Paper>
                    </Grid>
                  );
                })}
              </Grid>
            )}
          </Box>
        </Box>
      </Box>
    </Container>
    );
};

export default Dashboard;